import { Popup } from '../popup/popup';

/**
 * @deprecated use Popup class instead: import { Popup } from 'main.popup'
 */
export class PopupWindow extends Popup
{
	// No additional functionality, just for compatibility
}
